import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Icon from '../../../../../ui/icons/Icon';
import iconsList from '../../../../../ui/icons/iconsList';
import classes from './ScoreboardHouse.module.css';

const ScoreboardHouseCarouselTab = ({ filters = [], onFilterChange, activeFilterId }) => {
    
    const { texts } = useSelector((state) => state.translate);
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const activeIndex = filters.findIndex((filter) => filter.id === activeFilterId);
        if (activeIndex !== -1) {
            setCurrentIndex(activeIndex);
        }
    }, [activeFilterId, filters]);

    const handleNext = () => {
        if (currentIndex < filters.length - 1) {
            setCurrentIndex(currentIndex + 1);
            onFilterChange?.(filters[currentIndex + 1].id);
        }
    };

    const handlePrev = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            onFilterChange?.(filters[currentIndex - 1].id);
        }
    };

    const canGoNext = currentIndex < filters.length - 1;

    return (
        <div className={classes.filterContainer} dir="rtl">
            <div className={classes.filterMenu}>
                <Icon name={iconsList.left} color={currentIndex > 0 ? "#070C43" : "#E2E8F0"} size={24} onClick={currentIndex > 0 ? handlePrev : undefined} className={`${classes.arrowButton} ${classes.arrowLeft} ${currentIndex > 0 ? '' : classes.arrowDisabled}`} />
                {filters.map((filter, index) => (
                    <div key={filter.id} className={`${classes.filterItem} ${activeFilterId === filter.id ? classes.activeFilter : ''} ${index === currentIndex ? classes.currentItem : ''}`} onClick={() => { setCurrentIndex(index); onFilterChange?.(filter.id); }}>
                        <p className={classes.filterText}>
                            {filter.titleKey ? texts[filter.titleKey] : filter.title}
                        </p>
                    </div>
                ))}
                <Icon name={iconsList.right} color={canGoNext ? "#070C43" : "#E2E8F0"} size={24} onClick={canGoNext ? handleNext : undefined} className={`${classes.arrowButton} ${classes.arrowRight} ${!canGoNext ? classes.arrowDisabled : ''}`} />
            </div>
        </div>
    );
};

export default ScoreboardHouseCarouselTab;
